import request from '@/utils/request'

export function listMeterWaters(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/meterWater.listMeterWaters',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}